import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  > h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 32px;
  }
`;

export const Question = styled.h2`
  color: #2d2d2d;
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 32px;

  > span {
    font-weight: 700;
  }
`;

export const FormSatisfactionSurvey = styled.form`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;

  div:last-child {
    > button {
      margin-left: auto;
    }
  }
`;

export const WrapperRadio = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;

  @media (min-width: 640px) {
    justify-content: start;
    gap: 54px;
  }
`;

export const WrapperRadioSquare = styled.div`
  display: flex;
  gap: 16px;
`;

export const Confirmation = styled.div`
  width: 100%;
  max-width: 680px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 24px;

  > h2 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
  }

  > p {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }

  > span {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 36px;
  }
`;
